module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.4c5bc0fc.svg";